function phoneValidator(value = '') {
  const { path, createError } = this

  if (!value || value.length === 0) {
    return true
  }

  return (
    (!!value && value.length !== 0 && value.match(/^\+\d{7,15}$/)) ||
    createError({
      path,
      message: 'common::validation_messages.incorrect_phone_format',
    })
  )
}

export default phoneValidator
